import { stringToEnum } from '@snap-types/util/enum';
import { z } from 'zod/v4';

import { type SortOrder } from './common';
import { QuoteStatus, SnapQuoteStatus } from './enums';

export const parsedSortParam = z.array(
  z.object({
    key: z.string(),
    order: z.enum(['asc', 'desc']).optional().default('asc'),
  }),
);

export type ParsedSortParam = z.infer<typeof parsedSortParam>;

export const StatusFilter = { ...QuoteStatus, ...SnapQuoteStatus };

const statusFilterSchema = stringToEnum(StatusFilter);

export const searchQuerystringSchema = z.object({
  q: z.string().optional(),
  status: statusFilterSchema.optional(),
  customer: z.string().optional(),
  quoteId: z.string().optional(),
  createdByDisplayName: z.string().optional(),
  createdByTeamCode: z.string().optional(),
  assignedToDisplayName: z.string().optional(),
  sort: z
    .transform(
      (value): z.input<typeof parsedSortParam> =>
        decodeURIComponent(String(value ?? ''))
          .split(',')
          .map((s) => {
            const [key, order] = s.split(':');
            return { key, order: (order as SortOrder) ?? 'asc' };
          }),
    )
    .pipe(parsedSortParam),
});

// TODO(mrs): Relocate to models/enums
export enum SnapSuggestionStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXCLUDED = 'EXCLUDED',
  UNKNOWN = 'UNKNOWN',
}

export const snapSuggestionStatusSchema = stringToEnum(SnapSuggestionStatus);
